import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _ChromeIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1 12C1 9.58672 1.77714 7.35494 3.09482 5.54129C3.12632 5.48923 3.16276 5.43979 3.20392 5.39371C5.21106 2.72551 8.40402 1 12 1C16.4881 1 20.3484 3.68785 22.059 7.54165C22.0787 7.57978 22.096 7.61934 22.1108 7.66014C22.683 8.99165 23 10.4588 23 12C23 18.0751 18.0751 23 12 23C11.6073 23 11.2193 22.9794 10.8372 22.9393C10.7918 22.9374 10.7463 22.9323 10.7011 22.9241C5.23811 22.2815 1 17.6357 1 12ZM12.5876 20.9811C17.2843 20.6785 21 16.7732 21 12C21 10.9481 20.8195 9.93834 20.4879 9H16.0004C16.6281 9.83566 17 10.8744 17 12C17 12.9831 16.7162 13.9 16.2262 14.6732L12.5876 20.9811ZM12.5954 16.9649L10.3544 20.8499C6.16969 20.0767 3 16.4085 3 12C3 10.5702 3.3334 9.21832 3.92671 8.01779L7.56725 14.3154C8.40246 15.9111 10.0741 17 12 17C12.2015 17 12.4001 16.9881 12.5954 16.9649ZM14.6363 13.4329C14.6214 13.4546 14.6072 13.4771 14.5938 13.5003L14.5195 13.6293C13.9849 14.4542 13.0562 15 12 15C10.918 15 9.96981 14.4272 9.44208 13.5683C9.43095 13.5451 9.41884 13.5222 9.40574 13.4995L9.32645 13.3623C9.11772 12.9535 9 12.4905 9 12C9 10.3431 10.3431 9 12 9C13.6569 9 15 10.3431 15 12C15 12.519 14.8682 13.0071 14.6363 13.4329ZM5.15842 6.15228L7.40178 10.033C8.16573 8.24947 9.93695 7 12 7H19.4845C17.8699 4.58803 15.1204 3 12 3C9.26175 3 6.80911 4.22287 5.15842 6.15228Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const ChromeIcon = assignWithoutSideEffects(_ChromeIcon, {
  componentId: 'ChromeIcon',
});

export default ChromeIcon;
